import { render, staticRenderFns } from "./OrderCountdown.vue?vue&type=template&id=60e55ad2&"
import script from "./OrderCountdown.vue?vue&type=script&lang=js&"
export * from "./OrderCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports